import { tenantEnvironment } from 'src/environments/environment.common';
import { DeploymentTier } from '@app/models/constants/deployment-tiers';
import { Tenant } from '@app/models/constants/tenants';

export const environment = tenantEnvironment({
	deploymentTier: DeploymentTier.STAGING,
	tenant: Tenant.UNION,
	systemVersion: 'TEST V2',
	systemVersionColor: 'red',
	title: '[TEST] ImmoInvoice',
	backgroundImagePath: '/assets/img/tenants/union/bg-test.jpg',
	baseUrl: 'https://uirtest.eucon.com/backend/api',
	featureConfig: {
		assetType: true,
		fastlaneOCRUpload: true,
		showSupportPage: { url: 'mailto:service-desk-re@eucon.com?subject=ImmoInvoice: Supportanfrage' },
		ilvTool: { url: 'https://uirtest.eucon.com/ilv/smart-invoice-login' },
		oldFrontendRedirect: { url: 'https://union-staging.frontend.dev-smartinvoice.eucon.com/' },
		hotjar: true
	},
	passwordRequirements: {
		minLength: 12,
		minRulesMet: 4
	}
});
